import menu from './menu.json'
import Layout from '../layout'


const developRoutes = getPath()

function getPath() {
  const path = []
  for (const i in menu) {
    const item = {
      path: '/open/' + menu[i].id, // 使用id作为path
      component: Layout,
      meta: { title: menu[i].name },
      children: getChildrenPath(menu[i].subMenu, menu[i].path, menu[i].id),
      hidden: false
    }
    path.push(item)
  }
  return path
}

function getChildrenPath(sub, parent, pid) {
  const childrenPath = []
  for (const j in sub) {
    const item = {
      path: '/open/product/' + pid + '/' + sub[j].id, // // 使用模块名'/open/product'加父id加子id作为path
      name: sub[j].name,
      component: () => import('../product/views' + parent + sub[j].path), // 文件所在位置
      meta: { title: sub[j].name },
    }
    childrenPath.push(item)
  }
  return childrenPath
}

export default developRoutes

// module.exports = { developRoutes }
